<section class="content-layout fullwidth-standard-normal-scroll h-full">
  <!-- Header -->
  <header class="header container flex align-center justify-between">
    <h1>Imports</h1>
    <section>
      <button mat-stroked-button (click)="openDownloadTemplateDialog()">
        <mat-icon class="mr-1 -ml-1">download</mat-icon>
        Download Template
      </button>
      <button mat-flat-button [color]="'primary'" class="ml-4" (click)="openImportStepperDialog()">
        <mat-icon class="mr-1 -ml-1" [svgIcon]="'add'"></mat-icon>
        New Import
      </button>
    </section>
  </header>

  <!-- Body -->
  <ng-container *ngIf="importListResults$ | async as importList; else LoadingOrError">
    <main class="main p-2">
      <ng-container *ngIf="importList.length > 0; else EmptyListTemplate">
        <ng-container *ngFor="let import of importList; let index = index">
          <section class="mb-2">
            <mat-accordion>
              <mat-expansion-panel #importPanel>
                <mat-expansion-panel-header>
                  <mat-panel-title class="flex justify-between items-center w-full">
                    <p>{{ import.name }}</p>
                    <article class="flex flex-row items-center">
                      <ng-container *ngIf="importRecordsRunState[index]">
                        <mat-progress-spinner
                          class="mr-2"
                          [mode]="'indeterminate'"
                          [diameter]="24"
                          [color]="'primary'"
                        ></mat-progress-spinner>
                      </ng-container>
                      <p>
                        <strong [style.color]="applyStatusColor(import.status)">{{
                          import.status | formatSnakeCase
                        }}</strong>
                      </p>
                      <button
                        class="ml-2"
                        mat-icon-button
                        [matMenuTriggerFor]="moreMenu"
                        (click)="$event.stopPropagation()"
                      >
                        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                      </button>
                      <mat-menu #moreMenu="matMenu">
                        <ng-container *ngIf="enableEditImportButton(import.status)">
                          <button mat-menu-item (click)="openImportStepperDialog(import)">
                            <mat-icon [svgIcon]="'edit'"></mat-icon>
                            Edit
                          </button>
                        </ng-container>
                        <button mat-menu-item (click)="deleteImport$(import)">
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                          Delete
                        </button>
                      </mat-menu>
                    </article>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <section
                  class="flex items-center justify-end mt-4"
                  [ngClass]="{ 'mb-4': import?.errors?.length || runImportError }"
                >
                  <ng-container *ngIf="enableRunButton(import.status)">
                    <button
                      mat-raised-button
                      class="ml-4"
                      [disabled]="import === selectedImport || import?.errors?.length || runImportError"
                      [color]="'primary'"
                      (click)="runImport(import, index)"
                      [matTooltip]="'Run import'"
                    >
                      Run
                    </button>
                  </ng-container>
                </section>

                <!-- Import Error section -->
                <ng-container *ngIf="import?.errors?.length || runImportError as runError">
                  <app-alert-banner [type]="'error'">
                    <ng-container *ngIf="import.errors as importErrors">
                      <ng-container *ngFor="let error of importErrors">
                        <p>{{ error }}.</p>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="runError">
                      <p>{{ runError.error }}</p>
                      <p class="mt-1">
                        You can fix the current file, upload a new one or choose a different mode option.
                      </p>
                    </ng-container>
                  </app-alert-banner>
                  <mat-divider class="mt-4 mb-2"></mat-divider>
                </ng-container>

                <!-- Columns from File or Mapped Fields Section -->
                <ng-container *ngIf="enableMappingSummaryView(import.status); else mappedColumnsFromFile">
                  <p>Mapped Fields:</p>
                  <section class="mapped-fields__container mb-2">
                    <ng-container *ngIf="import.mapping as mappedFields">
                      <mat-chip-list
                        aria-label="Mapped Fields"
                        class="import-chip-list"
                        *ngFor="let field of mappedFields | keyvalue"
                      >
                        <mat-chip color="primary">
                          {{ field.key }}
                          <mat-icon [svgIcon]="'arrow_right_alt'"></mat-icon>
                          {{ field.value?.label ? field.value.label : '(Field Unavailable)' }}
                        </mat-chip>
                      </mat-chip-list>
                    </ng-container>
                  </section>
                </ng-container>

                <ng-template #mappedColumnsFromFile>
                  <p>Columns found:</p>
                  <section class="mapped-fields__container mb-2">
                    <ng-container *ngIf="import.headers as headers">
                      <mat-chip-list aria-label="File columns">
                        <mat-chip *ngFor="let header of headers" color="primary">{{ header }}</mat-chip>
                      </mat-chip-list>
                    </ng-container>
                  </section>
                </ng-template>

                <mat-divider class="mt-4 mb-2"></mat-divider>

                <!-- File Name -->
                <p class="flex">
                  File name:
                  <a
                    class="link flex items-center ml-1"
                    (click)="downloadFile(import.document)"
                    [matTooltip]="'Download file'"
                  >
                    <strong>{{ import.document.public_name }}</strong>
                    <mat-icon class="icon-size-20" [color]="'primary'">download</mat-icon>
                  </a>
                </p>

                <mat-divider class="my-2"></mat-divider>

                <section class="flex">
                  <!-- Rows Processed -->
                  <ng-container *ngIf="import.rows_processed_count !== undefined">
                    <p>
                      Rows processed: <strong>{{ import.rows_processed_count }}</strong>
                    </p>
                  </ng-container>
                  <!-- Rows failed -->
                  <ng-container *ngIf="import.rows_failed_count !== undefined">
                    <p class="ml-4">
                      Rows failed: <strong>{{ import.rows_failed_count }}</strong>
                    </p>
                  </ng-container>
                  <!-- Records Created -->
                  <ng-container *ngIf="import.records_created_count !== undefined">
                    <p class="ml-4">
                      Records created: <strong>{{ import.records_created_count }}</strong>
                    </p>
                  </ng-container>
                  <!-- Records Updated -->
                  <ng-container *ngIf="import.records_updated_count !== undefined">
                    <p class="ml-4">
                      Records updated: <strong>{{ import.records_updated_count }}</strong>
                    </p>
                  </ng-container>
                </section>

                <ng-container *ngIf="import.failures_document">
                  <mat-divider class="my-2"></mat-divider>
                  <p class="flex">
                    Failures report:
                    <a
                      class="link flex items-center ml-1"
                      (click)="downloadFile(import.failures_document)"
                      [matTooltip]="'Download errors report'"
                    >
                      <strong>{{ import.failures_document.public_name }}</strong>
                      <mat-icon class="icon-size-20" [color]="'primary'">download</mat-icon>
                    </a>
                  </p>
                </ng-container>

                <mat-divider class="my-2"></mat-divider>

                <!-- Object Type -->
                <p>
                  Object type:
                  <strong>{{ import.related_to_type === 'Project' ? 'Deal' : import.related_to_type }}</strong>
                </p>

                <mat-divider class="my-2"></mat-divider>

                <!-- Import Mode -->
                <p>
                  Import mode:
                  <strong>{{ import.mode | formatSnakeCase }}</strong>
                </p>

                <mat-divider class="my-2"></mat-divider>

                <!-- Last Updated -->
                <p>
                  Last updated: <strong>{{ import.updated_at | date }}</strong> at
                  <strong>{{ import.updated_at | date: 'shortTime' }}</strong>
                </p>

                <mat-divider class="my-2"></mat-divider>

                <!-- Created By -->
                <p>
                  Created by: <strong>{{ import.user.name }}</strong> in
                  <strong>{{ import.created_at | date }}</strong> at
                  <strong>{{ import.created_at | date: 'shortTime' }}</strong>
                </p>
              </mat-expansion-panel>
            </mat-accordion>
          </section>
        </ng-container>
        <section class="flex justify-center mt-4">
          <ts-paginator
            [totalItems]="totalCount"
            [pageSize]="pageSize"
            [activePage]="currentPage"
            (pageChanged)="onPageChange($event)"
          ></ts-paginator>
        </section>
      </ng-container>
    </main>
  </ng-container>
</section>

<ng-template #LoadingOrError>
  <ng-container *ngIf="getImportListError$ | async; else Loading">
    <section class="w-full h-full flex flex-col justify-center items-center">
      <h3>Oops! Something went wrong...</h3>
      <h5>Unable to fetch imports list at this moment. Please try again later.</h5>
    </section>
  </ng-container>
  <ng-template #Loading>
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-template>
</ng-template>

<ng-template #EmptyListTemplate>
  <section class="no-imports w-full h-full flex flex-col justify-center items-center">
    <img class="no-imports__image" src="assets/images/empty_list.svg" alt="No Records Found" />
    <h5 class="mt-0 text-center">Looks like you haven't created any import records yet.</h5>
    <h5 class="m-0 text-center">Click on the 'New Import' button above to create one.</h5>
  </section>
</ng-template>
